import {gql} from '@apollo/client';
import {CatalogPlaylistComplete} from './CatalogPlaylistCompleteFragment';
import {CatalogSongComplete} from './CatalogSongCompleteFragment';

export const CatalogPlaylistWithSongs = {
  catalogPlaylist: gql`
    fragment CatalogPlaylistWithSongsFragment on Playlist {
      ...CatalogPlaylistComplete
      tracks {
        ...CatalogSongComplete
      }
    }
    ${CatalogPlaylistComplete.catalogPlaylist}
    ${CatalogSongComplete.catalogSong}
  `,
};
